import React, {useState} from "react";
import Modal from "react-modal";
import axios from "axios";
import {toast} from "react-toastify";
import ENUMS from "../../utils/ENUMS";
import moment from "moment";
import {BASE_URL} from '../../config.json'


const token = localStorage.getItem(ENUMS.AUTH);


const IncedentDeleteModal = ({user, getIncidents, selectedCourse}) => {

    const [modalIsOpen, setModal] = useState(false);
    const [resolveModalIsOpen, setResolveModal] = useState(false);


    const handleDelete = () => {
        setModal(true)
    }


    //Delete APi
    const removeUser = () => {
        axios.delete(`${BASE_URL}/club/incident/` + user.id, {
            headers: {
                Authorization: `Bearer ${token}`
            },

        }).then(res => {
            console.log(res, "RESPONSE")
            if (res.status == 201) {
                toast.success("Incident Deleted SuccessFully");
                //instead we can upadate the local state without refreshing api
                getIncidents(selectedCourse)
                setModal(false);
            } else {
                toast.error("Unable to Delete");
                setModal(false);

            }

        })
            .catch(err => {
                toast.error('Something Wents Wrong Please Give Proper details')
                console.log(err)
                setModal(false);
            })

    };

    const ResolveIssue = () => {

        var data = {};

        const url =
                `${BASE_URL}/club/resolve_incident/` +
            user.id;

        axios
            .post(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => {

                if (res.status == 201) {
                    toast.success("Incident Resolved SuccessFully");

                    getIncidents(selectedCourse)

                } else {
                    toast.error("Unable to Resolve");

                }

                setResolveModal(false)

            })
            .catch(err => {
                setResolveModal(false);
                console.log(err);
            });
    }


    return (
        <tr id="row1" key={user.id}>
            <td className="text-jost-sb-16-pri" id="cell1-0">{user.id}</td>
            <td className="text-jost-sb-16-pri" style={{whiteSpace: "nowrap"}} id="cell1-1">{moment(user.created_at.split('T')[0]).format('DD-MM-YY')}</td>
            <td className="text-jost-sb-16-pri" id="cell1-2">{user.created_at.split('T')[1].split('.')[0]}</td>
            <td className="text-jost-sb-16-pri" id="cell1-3">HOLE {user.holepoint.hole_index}</td>
            <td className="text-jost-sb-16-pri" id="cell1-4">{user.incident.label}</td>
            <td className="text-jost-sb-16-pri" id="cell1-5">{user.notes}</td>
            <td className="text-jost-sb-16-pri" id="cell1-6">{user.user.full_name}</td>
            <td id="cell1-6"> {user.status.label == 'resolved' ?
                <button className="btn-resolved">Resolved</button> :
                <button className="btn-resolve" onClick={() => setResolveModal(true)}>Resolve</button>}
            </td>
            <td id="cell1-6">
                <button
                    // onClick={() => removeUser(user.id) }
                    onClick={handleDelete}
                    style={{position: 'relative', cursor: "pointer"}}
                >
                    <img
                        src={require("../../assets/images/del/delete.svg").default}
                        alt=""
                    />

                </button>
                <Modal isOpen={modalIsOpen}
                       style={{
                           overlay: {
                               zIndex: '2',
                               backgroundColor: 'rgba(93.3,93.3,93.3,0.6)',
                               // opacity:'0.5'


                           },
                           content: {
                               position: 'absolute',
                               top: '45%',
                               left: '35%',
                               right: '35%',
                               bottom: '25%',
                               border: '1px solid #ccc',
                               background: '#fff',
                               overflow: 'auto',
                               WebkitOverflowScrolling: 'touch',
                               borderRadius: '4px',
                               outline: 'none',
                               padding: '20px',
                               display: 'flex',
                               alignItems: 'center',
                               justifyContent: 'center',
                               flexDirection: 'column',
                               boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
                               transition: 'all 3s',
                               transitionTimingFunction: 'linear'

                           }
                       }}
                >
                    <button target="_self" className="modal-content--cross" onClick={() => setModal(false)}>
                        <img src={require("../../../src/assets/images/cross/Group 6926.svg").default} alt=""/>
                    </button>
                    <div className="modal_billing">


                        <div className="modal-content" style={{boxShadow: "none", border: "none"}}>

                            <h1 className="modal-content--title text-jost-sb-18">Do you want to delete?</h1>
                            {/*<p className="modal-content--para text-ops-rg-16">{user.id}</p>*/}
                            <div className="modal-content--links">
                                <button href="#" target="_self" className="res-btn-primary"
                                        onClick={removeUser}
                                >delete
                                </button>
                                <button href="#" target="_self" className="res-btn-ternary"
                                        onClick={() => setModal(false)}>cancel
                                </button>

                            </div>
                        </div>
                    </div>s
                </Modal>


                <Modal isOpen={resolveModalIsOpen}
                       style={{
                           overlay: {
                               zIndex: '2',
                               backgroundColor: 'rgba(93.3,93.3,93.3,0.6)',
                               // opacity:'0.5'


                           },
                           content: {
                               position: 'absolute',
                               top: '45%',
                               left: '35%',
                               right: '35%',
                               bottom: '25%',
                               border: '1px solid #ccc',
                               background: '#fff',
                               overflow: 'auto',
                               WebkitOverflowScrolling: 'touch',
                               borderRadius: '4px',
                               outline: 'none',
                               padding: '20px',
                               display: 'flex',
                               alignItems: 'center',
                               justifyContent: 'center',
                               flexDirection: 'column',
                               boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
                               transition: 'all 3s',
                               transitionTimingFunction: 'linear'

                           }
                       }}
                >
                    <button target="_self" className="modal-content--cross" onClick={() => setResolveModal(false)}>
                        <img src={require("../../../src/assets/images/cross/Group 6926.svg").default} alt=""/>
                    </button>
                    <div className="modal_billing">


                        <div className="modal-content" style={{boxShadow: "none", border: "none"}}>

                            <h1 className="modal-content--title text-jost-sb-18">Do you want to resolve?</h1>
                            {/*<p className="modal-content--para text-ops-rg-16">{user.id}</p>*/}
                            <div className="modal-content--links">
                                <button href="#" target="_self" className="res-btn-primary"
                                        onClick={ResolveIssue}
                                >Resolve
                                </button>
                                <button href="#" target="_self" className="res-btn-ternary"
                                        onClick={() => setResolveModal(false)}>cancel
                                </button>

                            </div>
                        </div>
                    </div>
                </Modal>

            </td>
        </tr>
    )
}
export default IncedentDeleteModal